import React, { Fragment } from "react";
import { MODAL_NAME } from "./duck/constants";

import {
  Button,
  Input,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const AddProjectSpecialNoteModal = (props) => {
  // Globals
  const { activeModal, dismissModal } = props;
  // Local from state
  const { projectID } = props;
  const { specialNote } = props;
  // Action Triggers
  const { saveProjectSpecialNote, addProjectSpecialNoteUpdateNote } = props;
  return (
    <Fragment>
      <Modal
        isOpen={activeModal === MODAL_NAME}
        toggle={() => dismissModal(MODAL_NAME)}
      >
        <ModalHeader>Set Project Special Note</ModalHeader>
        <ModalBody>
          <Form>
            <Input
              type="textarea"
              height="300px"
              className="form-control"
              placeholder="Please add any special notes for this Project.."
              defaultValue={specialNote}
              onChange={(event) =>
                addProjectSpecialNoteUpdateNote(event.target.value)
              }
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={() => saveProjectSpecialNote(projectID, specialNote)}
          >
            Add Special Note
          </Button>
          <Button color="secondary" onClick={() => dismissModal(MODAL_NAME)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default AddProjectSpecialNoteModal;
